<div class="row wccard p-3">

  <div class="w-100">
    <div class="row">
      <div class="col d-flex flex-column">
        <span class="f-14 font-weight-600" style="color: #484B59;">Send Invite</span>
        <span class="f-12 font-weight-400 mt-1" style="color: #484B59;">Invite teammates via email and start collaborating
          instantly</span>
      </div>

      <!-- <div class="col text-right" *ngIf="!planDetails?.isteammember">
        <span class="ml-3 ats-cta-btn f-12 pointer" (click)="copyinvitelink()">
          <i class="fas fa-link"></i>
        </span>
      </div> -->

      <div class="col text-right" *ngIf="planDetails?.isteammember">
        <button data-testid="auto-app-team-management-button-1" class="btn-trms-white" (click)="leaveteammodal()">Leave Team</button>
      </div>

    </div>

    <div class="row">
      <div class="col-md-6">
        <label class="mb-0 mt-3">Enter Email ID</label>
        <input data-testid="auto-app-team-management-input-1" [formControl]="emailInput" placeholder="Enter Email ID" type="email" class="wc-form-control nobg mt-1">
        <p class="f-12 text-danger mt-1" *ngIf="emailInputError">Please enter a valid email</p>
      </div>
      <div class="col-md-4">
        <label class="mb-0 mt-3">Role</label>
        <select data-testid="auto-app-team-management-select-1" name="roleType" [(ngModel)]="roleType" (change)="selectRole($event)" placeholder="Select Role" class="wc-form-control nobg mt-1">
          <option value="null" disabled>Select Role</option>
          <option selected value="teammember">Team Member</option>
        </select>
        <p class="f-12 text-danger mt-1" *ngIf="roleInputError">Select a role</p>
      </div>
      <div class="col-md-2">

        <button data-testid="auto-app-team-management-button-2" class="btn-trms-medium w-100 mt-6" [ngClass]="{ 'bg-gray': planDetails?.isteammember || emailInputError,  'text-center': showInviteSpinner }"
          (click)="sendInvite()" [disabled]="showInviteSpinner || planDetails?.isteammember || emailInputError">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showInviteSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showInviteSpinner }">
            {{showInviteSpinner ? '' : 'Send Invite'}}
          </span>
        </button>

      </div>
    </div>
  </div>

</div>

<!-- For Choose Tabs -->
<div class="row mt-2">
  <div class="col p-3 wccard">
    <div class="d-flex mt-1 justify-content-between">

      <div class="d-flex align-items-center">
        <p class="pointer f-14 font-weight-500" [ngStyle]="{'color': showYourTeamTab ? '#2E93A1': '#484B59'}"
          (click)="onTabChange('your-team')">Your Team ({{teamListCount}})</p>

        <p class="pointer f-14 ml-4 font-weight-500" [ngStyle]="{'color': showPendingTab ? '#2E93A1': '#484B59'}"
          (click)="onTabChange('pending')" *ngIf="planDetails?.isteamadmin || showPendingTab">Pending ({{pendingListCount}})</p>

        <p class="pointer f-14 ml-4 font-weight-500" [ngStyle]="{'color': showInvitationTab ? '#2E93A1': '#484B59'}"
          (click)="onTabChange('invitation')">Invitation ({{InvitationListCount}})</p>
      </div>

      <div class="d-flex align-items-center">
        <div *ngIf="planDetails?.isteamadmin && showYourTeamTab && selectedTeams.length >=2">
          <div (click)="addCoinToCandidate()" class="d-flex justify-content-center align-items-center icon"  matTooltip="Add Credits" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-regular fa-coin"></i>
          </div>
        </div>
        <!-- <div *ngIf="showYourTeamTab && selectedTeams.length >=2">
          <div (click)="deleteCandidate()" class="d-flex justify-content-center align-items-center icon">
            <i class="fa-regular fa-trash"></i>
          </div>
        </div> -->

        <!-- <div *ngIf="showPendingTab && selectedTeams.length >=2">
          <div (click)="revokeInvitation()" class="d-flex justify-content-center align-items-center cross-icon">
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div> -->

        <div *ngIf="!showInvitationTab">
          <input data-testid="auto-app-team-management-input-2" [formControl]="searchInput" class="wc-form-control nobg" placeholder="Search" type="text">
        </div>
      </div>

    </div>
  </div>
</div>


<!-- For Your Team Tabs -->
<div class="row mt-1" *ngIf="showYourTeamTab">

  <!-- If Your Team Not Available -->
  <div *ngIf="tabList.length == 0 && !adminDetails" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
      </div>
    </div>
  </div>

  <!-- If Your Team Available -->
  <div class="col" *ngIf="tabList.length > 0 || adminDetails">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">
      <div class="col-md-5">
        <div class="d-flex">
          <label class="wc-checkbox mr-3 p-0">
            <input data-testid="auto-app-team-management-input-3" [(ngModel)]="selected" (change)="selectAll(selected)" [ngModelOptions]="{standalone: true}"
              type="checkbox" id="mycheck" name="mycheck">
            <i class="fas fa-check f-12"></i>
          </label>
          <div>
            <span class="f-14 font-weight-400" style="color: #969696;">
              Name
            </span>
          </div>
        </div>
      </div>

      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Role
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Credits
        </span>
      </div>
      <div class="col" *ngIf="planDetails?.isteamadmin">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Actions
        </span>
      </div>

    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngIf="adminDetails">
      <div class="col-md-5">
        <div class="d-flex align-items-center">
          <label class="wc-checkbox mr-2 mb-0 d-flex">
            <input data-testid="auto-app-team-management-input-4" disabled type="checkbox" id="mycheck" name="mycheck" [checked]="adminDetails?.selected" [(ngModel)]="adminDetails.selected"
              (change)="checkIfAllSelected(adminDetails, adminDetails?.selected)">
            <i class="fas fa-check f-12"></i>
          </label>

          <div>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-14" style="color: #484B59;"> {{adminDetails?.firstname}} {{adminDetails?.lastname}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-12" style="color: #969696;"> {{adminDetails?.loginemail}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{adminDetails?.role? adminDetails?.role : 'Admin'}}
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{adminDetails?.usedbasiccontactcreditscount ? adminDetails?.usedbasiccontactcreditscount : '0'}}/
          {{adminDetails?.receivedbasiccontactenrichmentcredits ? adminDetails?.receivedbasiccontactenrichmentcredits : '0'}}
        </span>
      </div>
      <!-- No actions for the admin's own row - crediting yourself as the admin doesn't apply; the
           admin draws directly from the team pool, unlike team members who hold a credit allowance. -->
      <div class="col" *ngIf="planDetails?.isteamadmin"></div>

    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngFor="let team of tabList; let i=index;">
      <div class="col-md-5">
        <div class="d-flex align-items-center">
          <label class="wc-checkbox mr-2 mb-0 d-flex">
            <input data-testid="auto-app-team-management-input-5" type="checkbox" id="mycheck" name="mycheck" [checked]="team?.selected" [(ngModel)]="team.selected"
              (change)="checkIfAllSelected(team, team?.selected)">
            <i class="fas fa-check"></i>
          </label>

          <div>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-14" style="color: #484B59;"> {{team?.firstname}} {{team?.lastname}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="font-weight-400 f-12" style="color: #969696;"> {{team?.inviteeemailid}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{ team?.role === 'teammember' ? 'Team Member' : (team?.role ? team.role : 'Team Member') }}
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{team?.balancebasiccontactenrichmentcredits ? team?.balancebasiccontactenrichmentcredits : '0'}}/{{team?.basiccontactenrichmentusagelimit ? team?.basiccontactenrichmentusagelimit : '0'}}
        </span>
      </div>
      <div class="col" *ngIf="planDetails?.isteamadmin">
        <div class="d-flex" *ngIf="selectedTeams.length < 2">
          <div (click)="addCoinToCandidate(team)" class="d-flex justify-content-center align-items-center icon"  matTooltip="Add Credits" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-regular fa-coin"></i>
          </div>

          <div (click)="openTransferAdminModal(team)" class="d-flex justify-content-center align-items-center icon" matTooltip="Make Admin" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-regular fa-user-shield"></i>
          </div>

          <div (click)="deleteCandidate(team)" class="d-flex justify-content-center align-items-center icon"  matTooltip="Delete" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-regular fa-trash"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


<!-- For Pending Tabs -->
<div class="row mt-1" *ngIf="showPendingTab">

  <!-- If Pending Not Available -->
    <div *ngIf="tabList.length == 0" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
      </div>
    </div>
  </div>

  <!-- If pending Available -->
  <div class="col" *ngIf="tabList.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">
      <div class="col-md-5">
        <div class="d-flex">
          <!-- <label class="wc-checkbox mr-3 p-0">
            <input data-testid="auto-app-team-management-input-6" [(ngModel)]="selected" (change)="selectAll(selected)" [ngModelOptions]="{standalone: true}"
              type="checkbox" id="mycheck" name="mycheck">
            <i class="fas fa-check"></i>
          </label> -->
          <div>
            <span class="f-14 font-weight-400" style="color: #969696;">
              Name
            </span>
          </div>
        </div>


      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Role
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Sent On
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Actions
        </span>
      </div>
    </div>

    <div class="row align-items-center mt-1 p-2 wccard" *ngFor="let team of tabList" [ngStyle]="{ 'background-color': team?.expired ? '#FAFAFA' : '#FFFFFF' }">
      <div class="col-md-5">
        <div class="d-flex align-items-center">
          <!-- <label class="wc-checkbox mr-2 mb-0 d-flex">
            <input data-testid="auto-app-team-management-input-7" type="checkbox" id="mycheck" name="mycheck" [checked]="team?.selected" [(ngModel)]="team.selected"
              (change)="checkIfAllSelected(team, team?.selected)">
            <i class="fas fa-check"></i>
          </label> -->

          <div>
            <p class="mb-1 pointer no-outline">
              <span class="f-14 font-weight-400" style="color: #484B59;"> {{team?.firstname | titlecase}} {{team?.lastname | titlecase}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="f-12 font-weight-400" style="color: #969696;"> {{team?.inviteeemailid}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{ team?.role === 'teammember' ? 'Team Member' : (team?.role ? team.role : 'Team Member') }}
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">
          {{team?.createdon | date: 'MMM dd, yyyy' }}
        </span>
      </div>
      <div class="col">
        <div class="d-flex" *ngIf="!team?.expired">
          <div (click)="revokeInvitation(team)" class="d-flex justify-content-center align-items-center cross-icon"  matTooltip="Revoke" [matTooltipClass]="{ 'red-tooltip text-black': true }">
            <i class="fa-solid fa-xmark"></i>
          </div>
        </div>
        <span class="f-14 font-weight-400" style="color: #484B59;" *ngIf="team?.expired">Invitation Expired</span>
      </div>
    </div>
  </div>

</div>


<!-- For Invitation Tabs -->
<div class="row mt-1" *ngIf="showInvitationTab">

  <!-- If Invitation Not Available -->
    <div *ngIf="userRemindLaterInvites.length == 0" class="col wccard">
    <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
      <div>
        <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
        <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
      </div>
    </div>
  </div>

  <!-- If Invitation Available -->
  <div class="col" *ngIf="userRemindLaterInvites.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">

      <div class="col-md-5">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Invited By
        </span>
      </div>
      <div class="col-md-5">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Invited On
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Actions
        </span>
      </div>
    </div>

    <div class="row align-items-center mt-1 wccard" *ngFor="let team of userRemindLaterInvites" [ngStyle]="{ 'background-color': team?.expired ? '#FAFAFA' : '#FFFFFF' }">
      <div style="width: 4px; height: 59px;" [ngStyle]="{ 'background-color': team?.expired ? '#969696' : '#2E93A1' }"></div>
      <div class="col-md-5">
        <div class="d-flex align-items-center">
          <div>
            <p class="mb-1 pointer no-outline">
              <span class="f-14 font-weight-400" style="color: #484B59;">{{team?.adminfirstname | titlecase}} {{team?.adminlastname | titlecase}}</span>
            </p>
            <p class="mb-1 pointer no-outline">
              <span class="f-12 font-weight-400" style="color: #969696;">{{team?.adminemail}}</span>
            </p>
          </div>
        </div>
      </div>

      <div class="col">
        <span class="f-14 font-weight-400" style="color: #484B59;">{{team?.updatedon | date: 'dd MMM yyy'}}</span>

      </div>

      <div class="col">
          <div class="row" *ngIf="!team?.expired">
            <div class="col text-right">
              <button data-testid="auto-app-team-management-button-3" class="btn-trms-white mr-3" (click)="openRejectInvitationModel(team)">Reject</button>
              <button data-testid="auto-app-team-management-button-4" class="btn-trms-small" (click)="openConfirmInvitationModel(team)">Accept</button>
            </div>
          </div>
          <span class="f-14 font-weight-400" style="color: #484B59; margin-left: 100px;" *ngIf="team?.expired">Invitation Expired</span>
      </div>
    </div>
  </div>

</div>


<!-- For Add Credits to users model -->
<ng-template #addCreditToUser class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Add Credits to {{sendTeamToAPI?.length == 1 ? sendTeamToAPI[0].firstname + ' ' + sendTeamToAPI[0].lastname : sendTeamToAPI.length + ' User Selected'}}</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <span class="f-14 font-weight-400">Add credits from your balance to the {{sendTeamToAPI?.length == 1 ? sendTeamToAPI[0].firstname + ' ' + sendTeamToAPI[0].lastname : sendTeamToAPI.length + ' User Selected'}}.</span>
    <hr class="w-100">

    <div class="">
        <div class="d-flex align-items-center justify-content-between">
          <p class="f-14 font-weight-400" style="color: #484B59;">Available Team Credits</p>
          <p class="f-14 font-weight-400" style="color: #484B59;">{{planDetails?.pooledbalancebasiccontactenrichmentcredits}}</p>
        </div>

         <div class="d-flex align-items-center justify-content-between" *ngIf="sendTeamToAPI?.length == 1">
          <p class="f-14 font-weight-400" style="color: #484B59;">Available Credits With {{sendTeamToAPI[0]?.firstname + ' ' + sendTeamToAPI[0]?.lastname}}</p>
          <p class="f-14 font-weight-400" style="color: #484B59;">{{sendTeamToAPI[0].balancebasiccontactenrichmentcredits ? sendTeamToAPI[0].balancebasiccontactenrichmentcredits : '0'}}</p>
        </div>

         <div class="d-flex align-items-center justify-content-between">
          <p class="f-14 font-weight-400" style="color: #484B59;">Credits to Add</p>
          <input data-testid="auto-app-team-management-input-8" type="number" [formControl]="creditInput" placeholder="500"
          style="width: 57px; height: 37px; outline: none; border: 1px solid #D9D9D9; border-radius: 2px; text-align: center;" [ngStyle]="{'border-color': creditExceedError ? 'red' : '#D9D9D9'}">
        </div>

        <div class="text-start text-danger mt-1" *ngIf="creditExceedError">
          <li>Credits to add cannot exceed available credits</li>
        </div>
        <div class="text-start text-danger mt-1" *ngIf="creditBelowError">
          <li>Credits to add cannot below 1</li>
        </div>

        <div class="text-right">
          <button data-testid="auto-app-team-management-button-5" class="mt-5 text-center" [ngClass]="{'btn-trms-small': true,
                                  'bg-gray': creditExceedError || creditBelowError || !creditInput.value,
                                  'btn-disabled': creditExceedError || creditBelowError || !creditInput.value}"
            (click)="sendTeamToAPI[0].loginemail ? addCoinToAdminAPI() : addCoinToCandidateAPI()"
            [disabled]="showSpinnerLoader || creditExceedError || creditBelowError || !creditInput.value">
            <span [ngClass]="{ 'spinner-border text-white spinner-size': showSpinnerLoader }"
              [ngStyle]="{ width: showSpinnerLoader ? '20px' : '', height: showSpinnerLoader ? '20px' : '' }">
              {{ showSpinnerLoader ? '' : 'Add Credits' }}
            </span>
          </button>
        </div>
    </div>
  </div>
</ng-template>


<!-- For Delete users model -->
<ng-template #deleteUserModel class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Remove User</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">You're about to remove {{sendTeamToAPI[0].firstname | titlecase}} {{sendTeamToAPI[0].lastname | titlecase}}</p>
    <p class="f-14 font-weight-400">Their remaining credits will be added to the Team Credit Pool.</p>

    <div class="row">
      <div class="col text-right">
      <button data-testid="auto-app-team-management-button-6" class="btn-trms-white mr-3" [ngClass]="{ 'text-center': showSpinnerLoader }"
        (click)="deleteCandidateFromTeam()" [disabled]="showSpinnerLoader">
        <span [ngClass]="{ 'spinner-border text-blue spinner-size': showSpinnerLoader }"
          [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
          {{showSpinnerLoader ? '' : 'YES'}}
        </span>
      </button>
        <!-- <button data-testid="auto-app-team-management-button-7" class="btn-trms-white mr-3" (click)="deleteCandidateFromTeam()">{{showSpinnerLoader ? '' : 'YES'}}</button> -->
        <button data-testid="auto-app-team-management-button-8" class="btn-trms-small" (click)="dismiss()">NO</button>
      </div>
    </div>

  </div>
</ng-template>



<!-- For Revoke users model -->
<ng-template #revokeUserModel class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Revoke Invitation</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">Are you sure you want to revoke this invitation?</p>

     <div class="row">
      <div class="col text-right">
          <button data-testid="auto-app-team-management-button-9" class="btn-trms-white mr-3" [ngClass]="{ 'text-center': showSpinnerLoader }" (click)="deleteCandidateFromTeam()"
            [disabled]="showSpinnerLoader">
            <span [ngClass]="{ 'spinner-border text-blue spinner-size': showSpinnerLoader }"
              [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
              {{showSpinnerLoader ? '' : 'YES'}}
            </span>
          </button>
        <button data-testid="auto-app-team-management-button-10" class="btn-trms-small" (click)="dismiss()">NO</button>
      </div>
    </div>


  </div>
</ng-template>



<!-- For Accept Invitation model -->
<ng-template #acceptInvitationModel class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Confirm Invitation</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">Confirming this invitation to {{sendTeamToAPI[0].adminfirstname + "'s"}} Workspace means you will forfeit access to your current workspace and all its contents. Are you certain?</p>

     <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-team-management-button-11" class="btn-trms-small" [ngClass]="{ 'text-center': showSpinnerLoader }" (click)="acceptInvitation()"
          [disabled]="showSpinnerLoader">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Confirm'}}
          </span>
        </button>
      </div>
    </div>


  </div>
</ng-template>


<!-- For Reject Invitation model -->
<ng-template #rejectInvitationModel class="modal">
  <div class="modal-content p-3">
    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Reject Invitation</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">Do you want to reject the invitation</p>
     <div class="row">
      <div class="col text-right">
         <button data-testid="auto-app-team-management-button-12" class="btn-trms-small" [ngClass]="{ 'text-center': showSpinnerLoader }" (click)="rejectInvitation()"
          [disabled]="showSpinnerLoader">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showSpinnerLoader }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showSpinnerLoader }">
            {{showSpinnerLoader ? '' : 'Confirm'}}
          </span>
        </button>
      </div>
    </div>


  </div>
</ng-template>

<!-- For Transfer Admin model -->
<ng-template #transferAdminModel class="modal">

  <div class="modal-content p-3">

    <div class="d-flex justify-content-between align-items-center">
      <p class="f-14 font-weight-600">Transfer Admin Role</p>
      <p class="pointer f-12" (click)="dismiss()"><i class="fa-solid fa-xmark"></i></p>
    </div>
    <p class="f-14 font-weight-400">
      You are about to transfer the Admin role to {{transferAdminTarget?.firstname | titlecase}} {{transferAdminTarget?.lastname | titlecase}}.
    </p>
    <p class="f-14 font-weight-400 mt-2">Once the transfer is complete:</p>
    <ul class="f-14 font-weight-400 pl-4 mb-2">
      <li>{{transferAdminTarget?.firstname | titlecase}} {{transferAdminTarget?.lastname | titlecase}} will become the new Admin.</li>
      <li>You will become a Team Member.</li>
      <li>You will no longer be able to manage team members or access Admin settings.</li>
    </ul>
    <p class="f-14 font-weight-400">This action will take effect immediately.</p>
    <p class="f-14 font-weight-400 mt-2">Type <strong>{{transferConfirmPhrase}}</strong> to continue.</p>
    <input data-testid="auto-app-team-management-input-9" [formControl]="transferConfirmInput" placeholder="{{transferConfirmPhrase}}" type="text" class="wc-form-control nobg mt-1">

    <p class="f-14 font-weight-400 mt-2">Reason <span class="font-weight-400">(optional)</span></p>
    <textarea data-testid="auto-app-team-management-textarea-1" [formControl]="transferReasonInput" placeholder="Why are you transferring the Admin role?" maxlength="100"
      rows="2" class="wc-form-control nobg mt-1"></textarea>
    <p class="f-12 text-muted mt-1 text-right">{{transferReasonInput.value?.length || 0}}/100</p>

    <p class="f-12 text-danger mt-1" *ngIf="transferAdminErrorMessage">{{transferAdminErrorMessage}}</p>

    <div class="row mt-3">
      <div class="col text-right">
        <button data-testid="auto-app-team-management-button-13" class="btn-trms-white mr-3" (click)="dismiss()">Cancel</button>

        <button data-testid="auto-app-team-management-button-14" class="btn-trms-small" [ngClass]="{ 'text-center': showTransferAdminSpinner, 'btn btn-secondary': transferConfirmValue !== transferConfirmPhrase }"
          (click)="confirmTransferAdmin()" [disabled]="showTransferAdminSpinner || transferConfirmValue !== transferConfirmPhrase || transferReasonInput.invalid">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showTransferAdminSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showTransferAdminSpinner }">
            {{showTransferAdminSpinner ? '' : 'Transfer Admin Role'}}
          </span>
        </button>
      </div>
    </div>

  </div>
</ng-template>


<!-- For Leave Team model -->
<ng-template #leaveteam>
  <div class="modal-header b pb-0 mb-5 d-flex justify-content-between">
    <h5 class="modal-title f-14" id="experience">Are you sure you want to leave this group?</h5>
    <button data-testid="auto-app-team-management-button-15" type="button" class="no-outline-border-btn p-1 ms-auto" data-dismiss="modal" aria-label="Close"
       (click)="dismiss()">
      <span><i class="fa-solid fa-xmark"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col text-right">
        <button data-testid="auto-app-team-management-button-16" class="btn-trms-white mr-3" (click)="dismiss()">NO</button>

         <button data-testid="auto-app-team-management-button-17" class="btn-trms-medium" [ngClass]="{'text-center': showTeamLeaveSpinner }"
          (click)="submitleaveteam()" [disabled]="showTeamLeaveSpinner">
          <span [ngClass]="{ 'spinner-border text-white spinner-size': showTeamLeaveSpinner }"
            [ngStyle]="{ 'width: 20px; height: 20px;': showTeamLeaveSpinner }">
            {{showTeamLeaveSpinner ? '' : 'YES'}}
          </span>
        </button>

        <!-- <button data-testid="auto-app-team-management-button-18" class="btn-trms-small" (click)="submitleaveteam()">YES</button> -->
      </div>
    </div>
  </div>
</ng-template>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info" (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
